import config from '@/config';

export default {
  isNewDate(date) {
    return ( new Date().getTime() - date.getTime() ) < config.restrictions.MATERIAL_NEW_MAX_DIFF_MS;
  },

  isNew(material) {
    if (!material?.published_date) return false;
    try {
      return this.isNewDate(new Date(material.published_date) );
    } catch {
      return false;
    }
  },
}
